// Cambridge A2 Flyers week_36_real.js (Restored Syllabus Data)
export default {
  "weekId": 36,
  "title": "My Adventure Book — Project 3 & Irregular Verbs Review",
  "title_vi": "Sách Phiêu Lưu Của Em — Dự Án 3 & Ôn Tập Động Từ Bất Quy Tắc",
  "target_vocab": [
    {
      "word": "adventure",
      "definition_en": "An exciting or daring experience",
      "definition_vi": "chuyến phiêu lưu",
      "example": "Leo wrote an adventure book.",
      "ipa": "/ədˈven.tʃər/"
    },
    {
      "word": "journey",
      "definition_en": "An act of traveling from one place to another",
      "definition_vi": "hành trình",
      "example": "His journey took him across the sea.",
      "ipa": "/ˈdʒɜː.ni/"
    },
    {
      "word": "explore",
      "definition_en": "To travel through an unfamiliar area to learn about it",
      "definition_vi": "khám phá",
      "example": "He explored a mysterious island.",
      "ipa": "/ɪkˈsplɔːr/"
    },
    {
      "word": "path",
      "definition_en": "A track laid down for walking",
      "definition_vi": "con đường nhỏ",
      "example": "Follow the path through the dense forest.",
      "ipa": "/pɑːθ/"
    },
    {
      "word": "forest",
      "definition_en": "A large area covered chiefly with trees",
      "definition_vi": "Khu rừng",
      "example": "The green forest was full of birds.",
      "ipa": "/ˈfɒr.ɪst/"
    },
    {
      "word": "mountain",
      "definition_en": "A large natural elevation of the earth's surface",
      "definition_vi": "ngọn núi",
      "example": "They climbed the high mountain.",
      "ipa": "/ˈmaʊn.tɪn/"
    },
    {
      "word": "island",
      "definition_en": "A piece of land surrounded by water",
      "definition_vi": "hòn đảo",
      "example": "The hidden island had secret caves.",
      "ipa": "/ˈaɪ.lənd/"
    },
    {
      "word": "map",
      "definition_en": "A diagrammatic representation of an area",
      "definition_vi": "bản đồ",
      "example": "He found an ancient treasure map.",
      "ipa": "/mæp/"
    },
    {
      "word": "compass",
      "definition_en": "An instrument for determining directions",
      "definition_vi": "la bàn",
      "example": "He used his compass to find north.",
      "ipa": "/ˈkʌm.pəs/"
    },
    {
      "word": "treasure",
      "definition_en": "A quantity of precious metals or valuable objects",
      "definition_vi": "kho báu",
      "example": "The treasure map showed an X mark.",
      "ipa": "/ˈtreʒ.ər/"
    },
    {
      "word": "discovered",
      "definition_en": "Found unexpectedly during a search",
      "definition_vi": "đã phát hiện",
      "example": "He discovered a wooden chest.",
      "ipa": "/dɪˈskʌv.əd/"
    },
    {
      "word": "travelled",
      "definition_en": "Went from one place to another",
      "definition_vi": "đã du lịch",
      "example": "Leo travelled by boat.",
      "ipa": "/ˈtræv.əld/"
    },
    {
      "word": "climbed",
      "definition_en": "Went up a steep slope or mountain",
      "definition_vi": "đã leo",
      "example": "He climbed up the mossy rock.",
      "ipa": "/klaɪmd/"
    },
    {
      "word": "crossed",
      "definition_en": "Passed from one side of a river or path to another",
      "definition_vi": "đã băng qua",
      "example": "He crossed the roaring river.",
      "ipa": "/krɒst/"
    },
    {
      "word": "reached",
      "definition_en": "Arrived at a destination",
      "definition_vi": "đã tới nơi",
      "example": "He reached the waterfall.",
      "ipa": "/riːtʃt/"
    },
    {
      "word": "returned",
      "definition_en": "Came back to a place",
      "definition_vi": "đã trở về",
      "example": "He returned home safely.",
      "ipa": "/rɪˈtɜːnd/"
    },
    {
      "word": "memory",
      "definition_en": "Something remembered from the past",
      "definition_vi": "kỷ niệm",
      "example": "Writing a book creates a great memory.",
      "ipa": "/ˈmem.ər.i/"
    },
    {
      "word": "illustration",
      "definition_en": "A picture illustrating a book or story",
      "definition_vi": "hình minh họa",
      "example": "He drew colorful illustrations.",
      "ipa": "/ˌɪl.əˈstreɪ.ʃən/"
    },
    {
      "word": "author",
      "definition_en": "A writer of a book or story",
      "definition_vi": "tác giả",
      "example": "Every student became a book author.",
      "ipa": "/ˈɔː.θər/"
    },
    {
      "word": "chapter",
      "definition_en": "A main division of a book",
      "definition_vi": "chương sách",
      "example": "Chapter One describes the island.",
      "ipa": "/ˈtʃæp.tər/"
    }
  ],
  "story_missions": [
    {
      "mission_id": 1,
      "title": "My Adventure Story",
      "mission_context": "Retell Leo's adventure book story using past irregular verbs (went, saw, found, took, made)."
    },
    {
      "mission_id": 2,
      "title": "Creating Project 3",
      "mission_context": "Explain how you illustrated and wrote your own adventure book chapters."
    },
    {
      "mission_id": 3,
      "title": "Author Presentation",
      "mission_context": "Present your completed adventure book project to the class."
    }
  ],
  "spark_talk": [
    {
      "topic_en": "Adventure Book Writing",
      "topic_vi": "Viết sách phiêu lưu",
      "cards": [
        "What irregular verbs did you use in Chapter 1?",
        "Where does your adventure story take place?"
      ]
    },
    {
      "topic_en": "Illustrating Stories",
      "topic_vi": "Vẽ minh họa câu chuyện",
      "cards": [
        "What picture did you draw for Chapter 2?",
        "Who is the main author of your book?"
      ]
    }
  ],
  "sentences": [
    "Welcome to Project 3: My Adventure Book!",
    "Leo went to a mysterious bay by boat.",
    "He saw a colorful parrot and found an ancient treasure map.",
    "He took out his compass and made his way across the jungle.",
    "Leo wrote five thrilling chapters and drew beautiful illustrations."
  ]
};
